/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { HierarchiesControllerGetDescendantsQueryResponse, HierarchiesControllerGetDescendantsPathParams, HierarchiesControllerGetDescendantsQueryParams, HierarchiesControllerGetDescendants401, HierarchiesControllerGetDescendants403 } from "../../models/hierarchiesController/HierarchiesControllerGetDescendants";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { hierarchiesControllerGetDescendants } from "../../clients/hierarchiesService/hierarchiesControllerGetDescendants";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const hierarchiesControllerGetDescendantsQueryKey = (scopeId: HierarchiesControllerGetDescendantsPathParams["scopeId"], params: HierarchiesControllerGetDescendantsQueryParams) => [{
  url: '/api/v1/hierarchies/:scopeId/descendants',
  params: {
    scopeId: scopeId
  }
}, ...(params ? [params] : [])] as const;
export type HierarchiesControllerGetDescendantsQueryKey = ReturnType<typeof hierarchiesControllerGetDescendantsQueryKey>;
export function hierarchiesControllerGetDescendantsQueryOptions(scopeId: HierarchiesControllerGetDescendantsPathParams["scopeId"], params: HierarchiesControllerGetDescendantsQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = hierarchiesControllerGetDescendantsQueryKey(scopeId, params);
  return queryOptions<HierarchiesControllerGetDescendantsQueryResponse, ResponseErrorConfig<HierarchiesControllerGetDescendants401 | HierarchiesControllerGetDescendants403>, HierarchiesControllerGetDescendantsQueryResponse, typeof queryKey>({
    enabled: !!(scopeId && params),
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return hierarchiesControllerGetDescendants(scopeId, params, config);
    }
  });
}

/**
 * @description Retrieve all child scopes recursively with optional depth limit. Supports filtering by scope type(s) using comma-separated values (e.g., scopeType=FILE,FOLDER)
 * @summary Get descendant scopes
 * {@link /api/v1/hierarchies/:scopeId/descendants}
 */
export function useHierarchiesControllerGetDescendants<TData = HierarchiesControllerGetDescendantsQueryResponse, TQueryData = HierarchiesControllerGetDescendantsQueryResponse, TQueryKey extends QueryKey = HierarchiesControllerGetDescendantsQueryKey>(scopeId: HierarchiesControllerGetDescendantsPathParams["scopeId"], params: HierarchiesControllerGetDescendantsQueryParams, options: {
  query?: Partial<QueryObserverOptions<HierarchiesControllerGetDescendantsQueryResponse, ResponseErrorConfig<HierarchiesControllerGetDescendants401 | HierarchiesControllerGetDescendants403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? hierarchiesControllerGetDescendantsQueryKey(scopeId, params);
  const query = useQuery({
    ...hierarchiesControllerGetDescendantsQueryOptions(scopeId, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<HierarchiesControllerGetDescendants401 | HierarchiesControllerGetDescendants403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}